import styled from "styled-components";
export const ClientContactResultWrapper = styled.div`
  .cell-contact-name {
    min-width: 220px;
  }
  .contact-name-wrapper {
    display: flex;
    align-items: center;
  }
  .cell-used-by-client {
    min-width: 300px;
  }
  .used-by-client-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .MuiTypography-root {
      width: -webkit-fill-available;
    }
  }
  .cell-contact {
    min-width: 200px;
  }
  .cell-status {
    min-width: 150px;
  }
  .cell-actions {
    min-width: 140px;
  }
  .action-btns {
    margin: 0 16px;
  }
  .client-contact-icon {
    margin-left: 8px;
  }
  .contact-name-link {
    width: 100px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .used-by-client-text {
    width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
